import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 8C2D4FBB-00B1-4815-971F-03F0788093C2
 * name vector-line
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/vector-line.svg
 * tags
 * - Vector 
 * - Geographic Information System 
 */
export const VectorLineIcon = createSvgIcon(<><path d="M15,3V7.59L7.59,15H3V21H9V16.42L16.42,9H21V3M17,5H19V7H17M5,17H7V19H5" /></>, 'VectorLineIcon');
export default VectorLineIcon